import { useQuery } from '@tanstack/react-query';

import { annualCalendarAPI } from '../../data/annualCalendar';
import { unwrap } from '../../data/api';
import { OVERVIEW_STALE_TIME } from '../../lib/queryDefaults';

export const calendarKeys = {
  all: ['calendar'],
  annual: (year) => [...calendarKeys.all, 'annual', year],
};


export function useAnnualCalendarQuery(year, queryOptions = {}) {
  return useQuery({
    queryKey: calendarKeys.annual(year),
    queryFn: () => annualCalendarAPI.get({ year }).then((r) => unwrap(r)),
    enabled: Boolean(year),
    staleTime: OVERVIEW_STALE_TIME,
    placeholderData: (prev) => prev,
    ...queryOptions,
  });
}
